import React, { createContext, useState, useContext } from "react";

// Create the context
const SelectedToursContext = createContext();

// Create a provider component
export const SelectedToursProvider = ({ children }) => {
  const [selectedTours, setSelectedTours] = useState([]);

  return (
    <SelectedToursContext.Provider value={{ selectedTours, setSelectedTours }}>
      {children}
    </SelectedToursContext.Provider>
  );
};

// Custom hook for accessing the context
export const useSelectedTours = () => {
  const context = useContext(SelectedToursContext);
  if (!context) {
    throw new Error(
      "useSelectedTours must be used within a SelectedToursProvider"
    );
  }
  return context;
};
